/**
 * Header component
 *
 * Top navigation bar for your site. Set to remain visible as the
 * user scrolls so that they can constantly reach any part of your page.
 */
import React, { useState, useEffect } from "react";

const Header = () => {
  const [dark, setDark] = useState(() => {
    return localStorage.getItem("theme") === "dark";
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", dark ? "dark" : "light");
    localStorage.setItem("theme", dark ? "dark" : "light");
  }, [dark]);

  return (
    <div
      style={{
        position: "fixed",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        alignItems: "center",
        gap: "0.5rem 1rem",
        background: "var(--header-bg)",
        color: "var(--text)",
        padding: "0.6rem 1rem",
        top: 0,
        width: "100%",
        zIndex: 10,
        boxShadow: "0 2px 10px var(--header-shadow)",
        boxSizing: "border-box",
      }}
    >
      <nav className="header-nav" style={{ display: "flex", gap: "1rem 1.5rem", flexWrap: "wrap", justifyContent: "center", flex: "1 1 auto" }}>
        <a href="#home">Home</a>
        <a href="#chatbot">Chat</a>
        <a href="#about">About</a>
        <a href="#portfolio">Portfolio</a>
        <a href="#footer">Contact</a>
      </nav>
      <button
        onClick={() => setDark(d => !d)}
        aria-label="Toggle dark mode"
        style={{
          background: "none",
          border: "1px solid var(--border)",
          borderRadius: "20px",
          cursor: "pointer",
          fontSize: "1.1rem",
          padding: "0.25rem 0.6rem",
          color: "var(--text)",
          flexShrink: 0,
        }}
      >
        {dark ? "☀️" : "🌙"}
      </button>
    </div>
  );
};

export default Header;
